
import { iCancelDetail } from '@/interface/result';
import { PageQuery } from '@/mixins/page_query';
import { Component, Prop, Mixins } from 'vue-property-decorator';
@Component
export default class extends Mixins(PageQuery) {
  @Prop() info!: iCancelDetail;
  url = 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg';

  /**
   * 得到终端类型
   * @param code
   * @private
   */
  private getClient(code: number) {
    let str: string = '其他';
    switch (code) {
      case 1:
        str = 'PC';
        break;
      case 2:
        str = '安卓';
        break;
      case 3:
        str = '盒子';
        break;
      case 5:
        str = 'IOS';
        break;
    }
    return str;
  }
}
